<script lang="ts">
	import { onMount } from 'svelte';
	import './layout.css';
	import favicon from '$lib/assets/favicon.svg';
	import OfflineBanner from '$lib/components/ui/OfflineBanner.svelte';
	import Toaster from '$lib/components/ui/Toaster.svelte';
	import { initAuth } from '$lib/firebase/auth';
	import { pwaInfo } from 'virtual:pwa-info';

	let { children } = $props();

	initAuth();

	onMount(async () => {
		if (pwaInfo) {
			const { registerSW } = await import('virtual:pwa-register');
			registerSW({
				immediate: true,
				onRegistered(r) {
					console.log('SW Registered:', r);
				},
				onRegisterError(error) {
					console.error('SW registration error', error);
				}
			});
		}
	});

	const webManifest = $derived(pwaInfo ? pwaInfo.webManifest.linkTag : '');
</script>

<svelte:head>
	<link rel="icon" href={favicon} />
	<!-- eslint-disable-next-line svelte/no-at-html-tags -->
	{@html webManifest}
</svelte:head>

<div class="min-h-screen flex flex-col">
	<OfflineBanner />
	<main class="flex-1 flex flex-col">
		{@render children()}
	</main>
	<Toaster />
</div>
